
<div style="width: 100%;">
  <div class="shopSearchResult">
    <div class="ui vertical loader" :class="{active: waiting && shops.length === 0}"></div>
    <slot name="banner" />
    <div v-show="!waiting" class="shopSearchResult__resultNumberContainer">
      宴会・パーティー会場検索結果<span class="shopSearchResult__resultNumber">{{ pager.total }}</span>件
    </div>
    <div v-show="!waiting" class="shopSearchResult__selectionListContainer">
      <div class="shopSearchResult__selectionListTitle">
        まとめて問い合わせリスト <span class="count">{{ $root.selectedShopCount }}</span> 件
      </div>
      <div class="shopSearchResult__selectionListHint">（最大10件選択可能です）</div>
    </div>

    <div class="shopSearchResult__shopList">
      <search-result-shop :shops="pr_shops" :is-promotion="true"></search-result-shop>
      <search-result-shop :shops="filteredShops"></search-result-shop>
    </div>
  </div>
  <front-pagination v-show="!waiting" :pager="pager" :form="form" />
</div>
